import { Close as CloseIcon, Menu as MenuIcon } from "@mui/icons-material";
import { AppBar, Box, IconButton, Toolbar, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import { Rw1Logo } from "../icons/Rw1Logo";
import { Sidebar } from "./Sidebar";

const drawerWidth = 280;

interface MainProps {
  children: React.ReactNode;
}

export const Main: React.FC<MainProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useIsMobile();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      {isMobile && (
        <AppBar
          position="fixed"
          sx={{
            width: "100%",
            zIndex: () => theme.zIndex.drawer + 1,
            boxShadow: "none",
          }}
        >
          <Toolbar
            sx={{
              backgroundColor: theme.colors.defaultBackground,
              justifyContent: "space-between",
              paddingX: 3,
            }}
          >
            <IconButton
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, color: theme.colors.text[0] }}
            >
              {mobileOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Rw1Logo height="24px" />
          </Toolbar>
        </AppBar>
      )}

      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: "100%",
            md: `calc(100% - ${drawerWidth}px)`,
          },
          height: "100vh",
          overflow: "auto",
          overflowX: "hidden",
          ...(isMobile && {
            marginTop: "64px",
            height: "calc(100dvh - 64px)",
          }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
